/* BP Motors · ficha de vehículo, versión galería: visor de fotos con fundido, esferas que se llenan y barra de reserva */
(function () {
  'use strict';
  var root = document.querySelector('.fx');
  if (!root) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------- Visor de fotos ---------- */
  var D = { images: [] };
  try { D = JSON.parse($('#fx-data').textContent); } catch (e) {}
  var imgs = D.images || [];
  var stage = $('#fz-stage'), layers = $$('.fz-l', stage || document), thumbsEl = $('#fx-thumbs'), filtersEl = $('#fx-filters');
  var cnt = $('#fx-count'), cap = $('#fx-cap'), lb = $('#fx-lb'), lbi = $('#fx-lbimg');
  if (stage && imgs.length && layers.length === 2) {
    var reMec = /motor|vano|equipo|evaporador|condensador|atp|cuadro|anagrama|refrigerante|llanta|neum[aá]tico|enganche/i;
    var reInt = /cabina|puesto|conductor|copiloto|asiento|salpicadero|interior|caja|acceso lateral|contrapuerta|cierres|volante|pantalla|mandos|selector|maletero|usb|plazas/i;
    imgs.forEach(function (m) {
      if (m.g) return;
      var a = m.a || '', part = a.indexOf('—') > -1 ? a.split('—').slice(1).join('—') : a;
      m.g = reMec.test(part) ? 'mec' : (reInt.test(part) ? 'int' : 'ext');
    });
    var names = { ext: 'Exterior', int: 'Interior', mec: 'Mecánica' };
    var groups = { all: imgs.length };
    imgs.forEach(function (m) { groups[m.g] = (groups[m.g] || 0) + 1; });
    var ths = [], vis = [], idx = 0, front = 0;
    imgs.forEach(function (m, i) {
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'fx-th';
      t.setAttribute('aria-label', 'Ver foto ' + (i + 1));
      var ti = document.createElement('img');
      ti.src = m.t; ti.alt = ''; ti.loading = 'lazy'; ti.width = 96; ti.height = 72;
      t.appendChild(ti);
      t.addEventListener('click', function () { go(i); });
      thumbsEl.appendChild(t);
      ths.push(t);
    });
    function paint(i) {
      var m = imgs[i], nx = layers[1 - front], pre = new Image();
      pre.onload = function () {
        nx.src = m.s; nx.alt = m.a || '';
        stage.style.setProperty('--bg', 'url("' + m.t + '")');
        nx.classList.add('on'); layers[front].classList.remove('on');
        front = 1 - front;
      };
      pre.src = m.s;
      var n = imgs[(i + 1) % imgs.length]; if (n) { var p2 = new Image(); p2.src = n.s; }
    }
    function sync() {
      var pos = vis.indexOf(idx);
      if (cnt) cnt.textContent = pad(pos + 1) + ' / ' + pad(vis.length);
      if (cap) cap.textContent = imgs[idx].a || '';
      ths.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      var th = ths[idx];
      if (th && thumbsEl.scrollTo) thumbsEl.scrollTo({ left: th.offsetLeft - thumbsEl.clientWidth / 2 + th.offsetWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
      if (lb && lb.classList.contains('on')) { lbi.src = imgs[idx].s; lbi.alt = imgs[idx].a || ''; }
    }
    function go(i) { idx = i; paint(i); sync(); }
    function step(d) { go(vis[(vis.indexOf(idx) + d + vis.length) % vis.length]); }
    function setFilter(k) {
      vis = [];
      imgs.forEach(function (m, i) { if (k === 'all' || m.g === k) vis.push(i); });
      ths.forEach(function (t, i) { t.hidden = vis.indexOf(i) < 0; });
      $$('button', filtersEl).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.k === k); });
      go(vis.indexOf(idx) < 0 ? vis[0] : idx);
    }
    var kinds = ['all'].concat(['ext', 'int', 'mec'].filter(function (k) { return groups[k]; }));
    if (kinds.length > 2) {
      kinds.forEach(function (k) {
        var b = document.createElement('button');
        b.type = 'button'; b.dataset.k = k;
        b.innerHTML = (k === 'all' ? 'Todas' : names[k]) + '<i>' + groups[k] + '</i>';
        b.addEventListener('click', function () { setFilter(k); });
        filtersEl.appendChild(b);
      });
    } else { filtersEl.hidden = true; }
    $('#fx-prev').addEventListener('click', function () { step(-1); });
    $('#fx-next').addEventListener('click', function () { step(1); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if ((e.key === 'Enter' || e.key === ' ') && lb) { e.preventDefault(); openLb(); }
    });
    var sx = null, moved = 0;
    stage.addEventListener('pointerdown', function (e) { sx = e.clientX; moved = 0; });
    stage.addEventListener('pointermove', function (e) { if (sx !== null) moved = Math.max(moved, Math.abs(e.clientX - sx)); });
    stage.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx; sx = null;
      if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); else if (moved < 6) openLb();
    });
    function openLb() { if (!lb) return; lb.classList.add('on'); lbi.src = imgs[idx].s; lbi.alt = imgs[idx].a || ''; document.body.style.overflow = 'hidden'; }
    function closeLb() { lb.classList.remove('on'); document.body.style.overflow = ''; }
    if (lb) {
      $('.x', lb).addEventListener('click', closeLb);
      $('.lp', lb).addEventListener('click', function () { step(-1); });
      $('.ln', lb).addEventListener('click', function () { step(1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      addEventListener('keydown', function (e) {
        if (!lb.classList.contains('on')) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') step(-1);
        if (e.key === 'ArrowRight') step(1);
      });
    }
    setFilter('all');
  }

  /* ---------- Esferas: se llenan y cuentan al aparecer ---------- */
  var dials = $$('.dial');
  function ease(t) { return 1 - Math.pow(1 - t, 3); }
  function fill(d, delay) {
    setTimeout(function () {
      d.classList.add('on');
      var n = $('.n', d), to = +d.dataset.count;
      if (!n || !to) return;
      var sep = d.dataset.sep === '1', t0 = performance.now(), dur = 1800;
      var fmt = function (v) { var r = String(Math.round(v)); return sep ? r.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : r; };
      if (reduce) { n.textContent = fmt(to); return; }
      (function tick(now) {
        var k = Math.min(1, (now - t0) / dur);
        n.textContent = fmt(to * ease(k));
        if (k < 1) requestAnimationFrame(tick);
      })(t0);
    }, delay);
  }
  if (dials.length) {
    if (io && !reduce) {
      var dio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          dials.forEach(function (d, i) { fill(d, 250 + i * 160); });
          dio.disconnect();
        });
      }, { threshold: 0.25 });
      dio.observe(dials[0].parentNode);
      setTimeout(function () { dials.forEach(function (d) { if (!d.classList.contains('on')) fill(d, 0); }); }, 9000);
    } else {
      dials.forEach(function (d) { fill(d, 0); });
    }
  }

  /* ---------- Barra flotante: aparece al salir de la cabecera y se aparta cerca del final ---------- */
  var dock = $('#fx-dock'), hero = $('#fx-hero');
  if (dock && hero && io) {
    var past = false, hold = false;
    var sync2 = function () {
      var on = past && !hold;
      dock.classList.toggle('on', on);
      if (on) dock.removeAttribute('inert'); else dock.setAttribute('inert', '');
    };
    new IntersectionObserver(function (es) {
      past = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      sync2();
    }, { threshold: 0 }).observe(hero);
    var seen = {};
    var hio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen[e.target.className || e.target.tagName] = e.isIntersecting; });
      hold = Object.keys(seen).some(function (k) { return seen[k]; });
      sync2();
    }, { threshold: 0.05 });
    $$('.fx-how .fx-cta, .fx-sell, .fx-more, footer').forEach(function (n) { hio.observe(n); });
  }

  /* ---------- Tarjetas «Otros en stock»: aparición ---------- */
  var cards = $$('.vc');
  function show(n) { n.classList.add('in'); }
  if (io && !reduce) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { show(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    cards.forEach(function (n) { cio.observe(n); });
    setTimeout(function () { cards.forEach(show); }, 9000);
  } else {
    cards.forEach(show);
  }
})();